import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import ButtonComponent from '@prisjakt/ui-button';
import ListOfExpertsComponent from '../../../expert/components/list-of-experts';
import ContentCardsComponent from '../../../expert/components/list-of-content-cards';

export const ExpertSection = styled.div`
  display: grid;
  grid-template-rows: 1fr auto;
  row-gap: ${layout.measurements.spacingMedium};
  margin-top: ${layout.measurements.spacingNormal};
`;

export const Section = styled.div`
  display: grid;
  grid-template-columns: 50% auto ${layout.measurements.spacingSmall};
  column-gap: ${layout.measurements.spacingNormal};

  ${media.mediumDown`
    grid-template-columns: 1fr;
    grid-template-rows: 1fr auto;
    row-gap: ${layout.measurements.spacingNormal};
  `}
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: ${layout.measurements.spacingNormal};
  }
`;

export const ExpertList = styled.div(
  p => css`
    display: flex;
    justify-content: flex-end;

    ${media.mediumDown`
      overflow: hidden;
      margin-bottom: ${layout.measurements.spacingSmall};
    `};
  `
);

export const List = styled.div`
  display: grid;
  row-gap: ${layout.measurements.spacingNormal};
`;

export const ContentList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: ${layout.measurements.spacingNormal};

  ${media.mediumDown`
    grid-template-columns: repeat(5, minmax(250px, 1fr));
    overflow-x: auto;

    &::after {
      // Adds spacing to the end of the scroll area
      content: '';
      display: block;
      width: 1px;
      margin-left: -${layout.measurements.spacingNormal};
      pointer-events: none;
    }
  `};
`;

export const ContentCards = styled(ContentCardsComponent)`
  margin: 1px;

  a {
    color: ${p => p.theme.text.primary};
  }
`;

export const Description = styled.div`
  display: grid;
  row-gap: ${layout.measurements.spacingSmall};
  line-height: 1.5;
`;

const ListOfExpertWidth = '448px';
export const ListOfExperts = styled(ListOfExpertsComponent)`
  width: ${ListOfExpertWidth};
  justify-content: flex-end;

  ${media.mediumDown`
    width: 100%;
    overflow-x: scroll;
    grid-template-columns: unset;
    grid-auto-flow: column;
    justify-content: flex-start;
  `};
`;

type ButtonProps = {
  $display: 'desktop' | 'mobile';
};

export const Button = styled(ButtonComponent)<ButtonProps>(
  p => css`
    display: ${p.$display === 'desktop' ? 'block' : 'none'};
    max-width: max-content;

    ${media.smallOnly`
      max-width: 100%;
      display: ${p.$display === 'mobile' ? 'block' : 'none'};
    `};
  `
);
